import React from "react";
import { Link } from "gatsby";
import ImageModule from "../../../modules/image_module";
import CTABtnModule from "../../../modules/cta_btn_module";
import { menuLinks } from "../../../common/utils/page_url_utils";
import { AnimationOnScroll } from "react-animation-on-scroll";

const TilesBox = ({item, imagename, strapi_id, processedImages, index, animation_effect, tiles_layout_type}) => {

    const ImageRenderList = ({item, imagename, strapi_id, processedImages}) => {
        return (
          <ImageModule ImageSrc={item.image} title={item.title} altText={item.title} imagetransforms={processedImages} renderer="srcSet" imagename={imagename} strapi_id={strapi_id} classNames="banner_img" />                           
        )
    }

    var page_link = item?.button_cta?.custom_link ? item.button_cta?.custom_link : item?.button_cta?.menu_item?.slug ? menuLinks(item.button_cta.menu_item) : "";

    var childern = <>
        <ImageRenderList item={item} imagename={imagename} processedImages={processedImages} strapi_id={strapi_id}/>
                    
        <span className="trans_bg"></span>
    
        {item.title || item.content || item.button_cta ? 
            <div className="tiles_content">
                <h3>{item.title} </h3>
                <p>{item.content} </p>

                {tiles_layout_type !== "text_under_image" &&
                    <CTABtnModule button_cta={item.button_cta}/>
                }
            </div>
            :
            <></>
        }
    </>

    return (
        <React.Fragment>
            {page_link ? 
                <Link to={page_link} className="tiles_link">
                    {/* <ImageModule ImageSrc={item.image} title={item.title} altText={item.title}  /> */}
                    {childern}
                    {tiles_layout_type === "text_under_image" &&
                        <CTABtnModule button_cta={item.button_cta} />
                    }
                </Link>
            : 
                <a href="javascript:;" className="tiles_link">
                    {childern}
                    {tiles_layout_type === "text_under_image" &&
                        <CTABtnModule button_cta={item.button_cta}/>
                    }
                </a>
            }
        </React.Fragment>
    );
};
export default TilesBox;